import { version } from "../package.json.js";
var devMsg = function devMsg(slug) {
  return "https://prismic.dev/msg/react/v".concat(version, "/").concat(slug);
};
export { devMsg };